import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import AudiotrackOutlinedIcon from "@mui/icons-material/AudiotrackOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import FullscreenOutlinedIcon from "@mui/icons-material/FullscreenOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

const FooterIconBar = (props) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const [showTeamDetailsBool, setShowTeamDetails] = useState(false);

  const menuTranslations = {
    en: {
      home: "Home",
      tutorial: "Tutorial",
      team: "Team",
      fullscreen: "Full Screen",
      themeAudio: "Theme Audio",
      autoplay: "Autoplay",
    },
    sl: {
      home: "මුල් පිටුව",
      tutorial: "උපදෙස්",
      team: "කණ්ඩායම",
      fullscreen: "පූර්ණ තිරය",
      themeAudio: "තේමා ශ්‍රව්‍ය",
      autoplay: "ස්වයංක්‍රීය ධාවනය",
    },
    tm: {
      home: "முகப்பு",
      tutorial: "வழிகாட்டி",
      team: "குழு",
      fullscreen: "முழுத்திரை",
      themeAudio: "தீம் ஆடியோ",
      autoplay: "தானியங்கி இயக்கம்",
    },
  };

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  const t = menuTranslations[language] || menuTranslations.en;

  useEffect(() => {
    const currentLanguage = localStorage.getItem("language") || "en";
    setLanguage(currentLanguage);
  }, []);

  const navigateToHome = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459643/LOCATION_CHANGE_oc2l0j.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    navigate("/");
  };

  const handleMenuToggle = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    setShowMenu((prev) => {
      const nextState = !prev;

      if (props.onMenuToggle) {
        props.onMenuToggle(nextState); // 🔔 notify parent
      }

      return nextState;
    });
  };

  // Close menu when clicking outside
  useEffect(() => {
    getTeamDetails();
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
        props.onMenuToggle?.(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showMenu]);

  const getTeamDetails = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Teams/getTeamDetails",
      );
      setShowTeamDetails(
        response.data.showTeamDetails?.toString().trim().toLowerCase() ===
        "true",
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <div className="footer-icon-container" style={{ position: "relative" }}>
      <div className="bottom-menu-icon" onClick={handleMenuToggle}>
        <MenuOutlinedIcon />
      </div>
      {showMenu && (
        <div className="footer-menu-dropdown" ref={menuRef}>
          <ul>
            <li onClick={navigateToHome}>
              <div className="d-flex align-items-center justify-content-start cursor-pointer">
                <HomeOutlinedIcon />
                <span className="ms-2">{t.home}</span>
              </div>
            </li>
            <li onClick={props.onOpenTutorial}>
              <div className="d-flex align-items-center justify-content-start cursor-pointer">
                <InfoOutlinedIcon />
                <span className="ms-2">{t.tutorial}</span>
              </div>
            </li>
            {showTeamDetailsBool && (
              <li onClick={props.onOpenTeam}>
                <div className="d-flex align-items-center justify-content-start cursor-pointer">
                  <PeopleOutlineOutlinedIcon />
                  <span className="ms-2">{t.team}</span>
                </div>
              </li>
            )}
            <li onClick={props.onFullscreenToggle}>
              <div className="d-flex align-items-center justify-content-start cursor-pointer">
                <FullscreenOutlinedIcon />
                <span className="ms-2">{t.fullscreen}</span>
              </div>
            </li>
            <li>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <AudiotrackOutlinedIcon />
                  <span className="ms-2">{t.themeAudio}</span>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={props.themeAudioEnabled}
                    onChange={props.themeAudioToggle}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </li>
            <li onClick={() => console.log("")}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <PlayArrowOutlinedIcon />
                  <span className="ms-2">{t.autoplay}</span>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={props.autoplayEnabled}
                    onChange={props.onAutoplayToggle}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default FooterIconBar;
